import React from "react";
import { Stack, Typography } from "@mui/material";

import { Label } from "./ShipmentInfo";
import { StyledCardRow, StyledHubHookFormDatePicker } from "./styles";
import { HubHookFormSelect } from "../HubHookFormSelect";
import { SHIPPING } from "../../constants";

const sx = {
  flexDirection: "row",
  gap: "10px",
  height: "100%",
  width: "100%",
  alignItems: "center",
};

export const ShipmentMethod = ({ poNumber }) => {
  return (
    <StyledCardRow sx={{ flexGrow: 0, borderBottom: 0 }}>
      <Stack sx={sx}>
        <Typography variant="subtitle2">Date:</Typography>
        <StyledHubHookFormDatePicker
          name="shipDate"
          shouldUnregister={false}
          disableHelperText
          required
        />
      </Stack>
      <Stack sx={sx} justifyContent="center">
        <Typography variant="subtitle2" noWrap>
          PO #:
        </Typography>
        <Typography variant="body2" fontWeight={500}>
          {poNumber}
        </Typography>
      </Stack>
      <Stack sx={sx} justifyContent="end">
        <Typography variant="subtitle2" noWrap>
          Ship Via:
        </Typography>
        <HubHookFormSelect
          name="shipVia"
          className="isLast"
          options={SHIPPING}
          shouldUnregister={false}
          formControlProps={{ sx: { width: "150px !important" } }}
          disableHelperText
          required
        />
      </Stack>
    </StyledCardRow>
  );
};
